import React from "react";
import { useSelector } from "react-redux";
import { isNoEditRoute } from "../../hooks/helpers";
import { webView } from "../../variables/webView";
// Styles come from a plain (non ?module) import of style.scss into
// assets/styles/react/app.scss, so these are the literal global class names —
// not a css-modules hash map — see docs/seo-prerendering-plan.md.
function BuildPrealoader({ toggle }) {
  const { preloaderToggle } = useSelector((state) => ({
    preloaderToggle: state.preloader.toggle,
  }));

  if (preloaderToggle || toggle) {
    return (
      <div className="loaderWrapper">
        {!isNoEditRoute && webView ? null : (
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <rect x="8" y="8" width="64" height="64"></rect>
            </svg>
          </div>
        )}
      </div>
    );
  } else {
    return <></>;
  }
}

export default BuildPrealoader;
